import React, { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, addDoc, query, where, getDocs, serverTimestamp } from 'firebase/firestore';
import BackHomeButton from '../components/BackHomeButton';
import { db, auth } from '../firebase';

function Support() {
  const [issueType, setIssueType] = useState('');
  const [issueDescription, setIssueDescription] = useState('');
  const [severity, setSeverity] = useState('Medium');
  const [submitting, setSubmitting] = useState(false);
  const [caseList, setCaseList] = useState([]);

  const user = getAuth().currentUser;
  //const db = getFirestore();

  const fetchUserCases = async () => {
    if (!user) return;
    const q = query(collection(db, 'support_cases'), where('uid', '==', user.uid));
    const snapshot = await getDocs(q);
    const data = snapshot.docs.map(doc => doc.data());
    setCaseList(data);
  };

  useEffect(() => {
    fetchUserCases();
  }, [user]);

  const handleSubmit = async () => {
    if (!issueType || !issueDescription || !severity) {
      alert('Please fill all fields.');
      return;
    }

    if (!user) {
      alert('Please login first.');
      return;
    }

    const caseId = 'CASE-' + Math.floor(100000 + Math.random() * 900000);
    const resolution = "";

    const supportData = {
      uid: user.uid,
      userEmail: user.email,
      issueType,
      issueDescription,
      severity,
      caseId,
      status: 'Open',
      timestamp: serverTimestamp(),
      resolution,
    };

    setSubmitting(true);
    try {
      await addDoc(collection(db, 'support_cases'), supportData);
      alert(`Support case submitted! Your case ID is ${caseId}`);
      setIssueType('');
      setIssueDescription('');
      setSeverity('Medium');
      fetchUserCases();
    } catch (error) {
      console.error(error);
      alert('Something went wrong.');
    }
    setSubmitting(false);
  };

  return (
    <div style={styles.card}>
      <BackHomeButton />
      <h2 style={styles.heading}>Support & Help</h2>

      <div style={styles.infoBox}>
        <p><strong>Welcome!</strong> Let us know what your Issue. We'll get back shortly.</p>
      </div>

      <div style={styles.inputGroup}>
        <label style={styles.label}>Issue Type</label>
        <select value={issueType} onChange={(e) => setIssueType(e.target.value)} style={styles.select}>
          <option value="">Select Issue</option>
          <option value="Login Issue">Login Issue</option>
          <option value="Upload Problem">Upload Problem</option>
          <option value="Feedback">Feedback</option>
          <option value="School_City_Missing">School or City Missing</option>
          <option value="Other">Other</option>
        </select>
      </div>

      <div style={styles.inputGroup}>
        <label style={styles.label}>Issue Description</label>
        <textarea
          value={issueDescription}
          onChange={(e) => setIssueDescription(e.target.value)}
          style={{ ...styles.input, height: '100px' }}
          placeholder="Describe your issue"
        />
      </div>

      <div style={styles.inputGroup}>
        <label style={styles.label}>Severity</label>
        <select value={severity} onChange={(e) => setSeverity(e.target.value)} style={styles.select}>
          <option value="Low">Low</option>
          <option value="Medium">Medium</option>
          <option value="High">High</option>
        </select>
      </div>

      <button onClick={handleSubmit} disabled={submitting} style={styles.button}>
        {submitting ? 'Submitting...' : 'Submit Support Request'}
      </button>

      <h3 style={{ marginTop: '2rem' }}>Your Open Cases</h3>
      <table style={styles.table}>
        <thead>
          <tr>
            <th>Case ID</th>
            <th>Issue</th>
            <th>Severity</th>
            <th>Status</th>
            <th>Resolution</th>
          </tr>
        </thead>
        <tbody>
          {caseList.length === 0 && (
            <tr><td colSpan="5">No cases found.</td></tr>
          )}
          {caseList.map((c, i) => (
            <tr key={i}>
              <td>{c.caseId}</td>
              <td>{c.issueType}</td>
              <td>{c.severity}</td>
              <td>{c.status}</td>
              <td>{c.resolution}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <footer style={styles.footer}>
        <p style={styles.footerText}>© 2026 Eascode All Rights Reserved.</p>
      </footer>
    </div>
  );
}

const styles = {
  card: {
    maxWidth: '480px',
    margin: '2rem auto',
    padding: '2rem',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 4px 14px rgba(0,0,0,0.1)',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  heading: {
    textAlign: 'center',
    fontSize: '1.8rem',
    fontWeight: '700',
    marginBottom: '1.5rem',
    color: '#333',
  },
  infoBox: {
    backgroundColor: '#f1f1f1',
    padding: '1rem',
    borderRadius: '8px',
    marginBottom: '1.5rem',
    fontSize: '0.95rem',
  },
  inputGroup: {
    marginBottom: '1.2rem',
  },
  label: {
    fontWeight: '600',
    color: '#444',
    marginBottom: '0.3rem',
    display: 'block',
  },
  input: {
    width: '100%',
    padding: '0.6rem 0.9rem',
    border: '1.5px solid #ccc',
    borderRadius: '8px',
    fontSize: '1rem',
  },
  select: {
    width: '100%',
    padding: '0.6rem 0.9rem',
    border: '1.5px solid #ccc',
    borderRadius: '8px',
    fontSize: '1rem',
    backgroundColor: '#fff',
  },
  button: {
    width: '100%',
    padding: '0.8rem',
    backgroundColor: '#4285f4',
    color: '#fff',
    fontSize: '1.1rem',
    border: 'none',
    borderRadius: '10px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 4px 10px rgba(66,133,244,0.4)',
    marginTop: '1rem',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '1rem',
    fontSize: '0.95rem',
  },
  footer: {
    marginTop: '3rem',
    padding: '1rem',
    backgroundColor: '#333',
    textAlign: 'center',
  },
  footerText: {
    color: '#fff',
    fontSize: '0.9rem',
  },
};

export default Support;
